module.exports = __webpack_public_path__ + "static/media/hsbc-logo.ef14812d.png";